enum TimePeriod {
  Days = "days",
  Week = "week",
  Month = "month",
}

export default TimePeriod;
